import { FC } from 'react';

import { Stack } from '@mui/material';

import { ReactComponent as LeftIcon } from '@/assets/icons/gallery-nav-left.svg';
import { ReactComponent as RightIcon } from '@/assets/icons/gallery-nav-right.svg';

interface Props {
  isPrev?: boolean;
  isDisabled?: boolean;
  onClick: () => void;
}

const ImageNavigationButton: FC<Props> = ({ isPrev, isDisabled, onClick }) => {
  return (
    <Stack
      padding="1.25rem"
      alignItems="center"
      justifyContent="center"
      sx={{
        cursor: isDisabled ? 'default' : 'pointer',

        '& > svg>path': {
          fill: (theme) => (isDisabled ? theme.palette.grey[300] : theme.palette.grey[700]),
        },
      }}
      onClick={() => {
        if (!isDisabled) {
          onClick();
        }
      }}
    >
      {isPrev ? <LeftIcon /> : <RightIcon />}
    </Stack>
  );
};

export default ImageNavigationButton;
